import React from 'react';

import { CrossCircle } from '@zooplus/icons';
import {
  H3,
  ModalBody,
  ModalFooter,
  ModalSecondaryButton,
  ModalWrapper,
  P1,
} from '@zooplus/ui-components';

import { useTranslation } from '@hooks/useTranslations';
import AdobeTrackingService from '@services/AdobeTrackingService';
import { braintreeTracking } from '@services/diiService';
import { PspConnector } from '@types-internal';

export type RetryPaymentCreditCardModalErrorProps = {
  show: boolean;
  connector: PspConnector;
};

const RetryPaymentCreditCardModalError: React.FC<RetryPaymentCreditCardModalErrorProps> = ({
  show,
  connector,
}) => {
  const { t } = useTranslation();

  const redirectToOrderOverviewPage = () => {
    if (connector === 'BRAINTREE') {
      braintreeTracking('BTretryPopupErrorClose');
    } else if (connector === 'ADYEN') {
      AdobeTrackingService.adyenTracking('AdyenRetryPopupErrorClose');
    }
    window.location.replace(window.location.origin + window.location.pathname);
  };

  return (
    <ModalWrapper
      size="md"
      isOpen={show}
      onClose={() => {
        redirectToOrderOverviewPage();
      }}
      heading={t('checkout.payment.by.card')}
      closeBtnAriaLabel="Close"
      headingId="retry-credit-card-error-modal">
      <ModalBody className={'v3-text--center'} data-zta="retry-credit-card-error-modal">
        <CrossCircle aria-label="Cross Circle" color="#e10000" height={60} width={60} />
        <H3>{t('mzp.order.detail.retry.payment.credit_card.error.title')}</H3>
        <P1>{t('general.error.internal')}</P1>
      </ModalBody>
      <ModalFooter>
        <ModalSecondaryButton onClick={() => redirectToOrderOverviewPage()}>
          {t('general.button.close')}
        </ModalSecondaryButton>
      </ModalFooter>
    </ModalWrapper>
  );
};

export default RetryPaymentCreditCardModalError;
